import { useEffect, useState } from "react";
import { makeRequestAuth } from "../../../_config/api";

const SplineChart = ({ propertyYear, contactYear, touchYear }) => {
  const [summaryData, setSummaryData] = useState([
    { title: "Total Properties", value: 0 },
    { title: "Total Contacts", value: 0 },
    { title: "Total Touches", value: 0 },
  ]);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const response = await makeRequestAuth("post", "/admin/dashboardData", {
          propertyYear,
          contactYear,
          touchYear,
        });

        if (response?.code === 0 && !response.error) {
          setSummaryData([
            { title: "Total Properties", value: response?.data.totalProperties },
            { title: "Total Contacts", value: response?.data.totalContacts },
            { title: "Total Touches", value: response?.data.totalTouches },
          ]);
        } else {
          console.error("Server Error:", response?.data?.message || "Unknown error");
        }
      } catch (error) {
        console.error("Dashboard data fetch failed:", error);
      }
    };

    fetchDashboardData();
  }, [propertyYear, contactYear, touchYear]);

  return (
    <section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {summaryData.map((item, index) => (
        <div
          key={index}
          className="bg-white rounded-2xl shadow-md p-6 w-full"
        >
          <h2 className="text-sm font-semibold text-gray-600">{item.title}</h2>
          <p className="text-3xl font-bold text-gray-800 mt-2">{item.value}</p>
        </div>
      ))}
    </section>
  );
};

export default SplineChart;
